/**
 * A4-Seitengeometrie in PDF-Punkten.
 *
 * Aus `@kit/self-disclosure` herausgelöst (Spec `2026-07-30-legal-pdf-renderer.md`, PR-2).
 * Die Werte sind unverändert übernommen — der Umzug ist ausdrücklich verhaltensneutral,
 * abgesichert durch den Golden-Master in `self-disclosure/__tests__/render-golden.test.ts`.
 */

export const PAGE_WIDTH = 595.28; // A4 portrait
export const PAGE_HEIGHT = 841.89;
export const MARGIN = 56;
export const CONTENT_WIDTH = PAGE_WIDTH - MARGIN * 2;

/** Maximale Blockhöhe, bevor der Degenerate-Guard greift. */
export const USABLE_PAGE_HEIGHT = PAGE_HEIGHT - 2 * MARGIN;
